const faqs = [
    { 
        id: 1, 
        heading: 'How much does solar cost?',
        content: 'The price of a solar system depends on your energy usage, roof size, location, and chosen equipment. We offer options for all budgets, from small home setups to large commercial systems.',
    },
    {
        id: 2,
        heading: 'What are my payment options?',
        content: 'We provide flexible payment plans, including upfront purchase, financing, and leasing. You can also benefit from government incentives and rebates to reduce costs.',
    },
    { 
        id: 3,
        heading: 'Why choose a solar provider?',
        content: 'Working with us ensures professional installation, high-quality panels, and ongoing support. We manage everything from design to permits so you can enjoy hassle-free solar energy.',
    },
    {
        id: 4,
        heading: 'How long is installation?',
        content: 'Most residential systems take 1–3 days to install after permits are approved. Larger or more complex projects may require additional time.',
    },
    {
        id: 5,
        heading: 'What solar services do you offer?',
        content: 'We offer panel installation, battery storage solutions, EV charger setup, maintenance, and energy audits to maximize your solar benefits.',
    },
];

export default faqs;